import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { useHistory } from 'react-router-dom'

import { ReactComponent as OrderIcon } from 'assets/icons/shipping.svg'

import { maskDate } from 'util/masks'
import { getOrderList } from '../redux/actions'
import { objToQueryString } from 'util/index'

import Search from 'util/modules/Pagination/components/Search'

type FilterType = { fields: string, [x: string]: string | number, start: string, end: string }

const start = (new Date()).toLocaleDateString('pt-BR')
const end = (new Date()).toLocaleDateString('pt-BR')
const initialState = {
  fields: (
    'id,status.alias,status.color,paymentMethod,partner.id,partner.name,partner.pictureTiny,reviewStars,createdAt'
  ),
  'filter_not[status.name]': 'CREATED',
  'filter[id]': 0,
  'filter[partner.id]': 0,
  start,
  end
}

const OderForm: React.FC = () => {
  const dispatch = useDispatch()
  const history = useHistory()
  const { location: { search } } = history

  const [filter, setFilter] = useState<FilterType>(initialState)
  const gridTemplateColumns = '100px 1fr 200px 200px 150px'

  function handleDateFormat (filter: FilterType): FilterType {
    if (!filter['filter[id]']) delete filter['filter[id]']
    if (!filter['filter[partner.id]']) delete filter['filter[partner.id]']

    return {
      ...filter,
      start: filter.start.split('/').reverse().join('-'),
      end: filter.end.split('/').reverse().join('-')
    }
  }

  function handleSubmit (e: React.FormEvent): void {
    e.preventDefault()
    history.push(`/panel/order?${objToQueryString(handleDateFormat(filter))}`)
  }

  useEffect(() => {
    if (search) {
      const query = Object.fromEntries(new URLSearchParams(search))
      getOrderList(handleDateFormat(query as any))(dispatch)
    }
  }, [search, dispatch])

  useEffect(() => {
    getOrderList(handleDateFormat(filter))(dispatch)
  }, [dispatch])

  return (
    <div className="row panel global-search">
      <div className="row justify-start">
        <h2><OrderIcon height="20" width="35" /> Buscar Pedido</h2>
        <form className="row align-end" style={{ display: 'grid', gridTemplateColumns }} onSubmit={handleSubmit}>
          <div className="form-control">
            <label>Código</label>
            <input
              type="number"
              value={filter['filter[id]'] || 0}
              onChange={(e): void => setFilter({ ...filter, 'filter[id]': parseInt(e.target.value) })}
            />
          </div>

          <div className="form-control">
            <label>Parceiro</label>
            <Search
              url="/partner"
              label='name'
              filter='name'
              fields='id,name'
              filterType="filter_like"
              match={['start']}
              selected={String(filter['filter[partner.id]'])}
              options={{ returnKey: 'id', renderValue: 'name' }}
              onSelect={(id): void => setFilter({ ...filter, 'filter[partner.id]': Number(id) })}
            />
          </div>

          <div className="form-control">
            <label>De</label>
            <input
              required
              type="text"
              value={filter.start}
              onChange={(e): void => setFilter({ ...filter, start: maskDate(e.target.value, '/') })}
            />
          </div>
          <div className="form-control">
            <label>Até</label>
            <input
              required
              type="text"
              value={filter.end}
              onChange={(e): void => setFilter({ ...filter, end: maskDate(e.target.value, '/') })}
            />
          </div>

          <button className="primary">
            <i className="fas fa-search"/> Buscar
          </button>
        </form>

      </div>
    </div>

  )
}

export default OderForm
